import { ReactNode } from 'react'

type Props = {
  label: string
  message?: string | null
  children: ReactNode
}

export function FormField({ label, message, children }: Props) {
  return (
    <label className="grid gap-1 text-sm">
      <span>{label}</span>
      {children}
      {message ? <span className="text-xs text-danger">{message}</span> : null}
    </label>
  )
}

